var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicOn = function SvgMicOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    d: "M0 0H21V18H0z",
    transform: "translate(.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.557 11.368c1.572 0 2.842-1.27 2.842-2.842V2.842C13.399 1.27 12.129 0 10.557 0 8.984 0 7.715 1.27 7.715 2.842v5.684c0 1.573 1.269 2.842 2.842 2.842zm5.599-2.842c-.465 0-.853.341-.929.806-.388 2.226-2.33 3.931-4.67 3.931s-4.282-1.705-4.67-3.931c-.077-.465-.465-.806-.93-.806-.577 0-1.032.512-.947 1.08.465 2.842 2.738 5.069 5.6 5.476v1.97c0 .522.426.948.947.948.52 0 .947-.426.947-.947v-1.97c2.861-.408 5.135-2.635 5.599-5.477.095-.568-.37-1.08-.947-1.08z",
    transform: "translate(.5)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic-on.0dd1620f61b1009edd628cf64955e8fa.svg";